import { ViewModel } from 'view_models/view_model'
import { RequestFormError } from 'entities/request_form_error'

export class RequestFormErrorViewModel extends ViewModel<RequestFormError> {
    public items = (): Record<string, string> => {
        if (this.object.items) {
            return JSON.parse(this.object.items)
        } else {
            return {}
        }
    }
}
